import {awaitingFulfillmentCountSelector} from '../../data/orderCounts.js'
import {canUseOrdersSelector} from '../../data/orders.js'
import {canUseProductsSelector} from '../../data/products.js'
import {defaultProductListHashSelector} from '../ProductListPage/productListFunctions.js'
import {defaultPurchaseOrderListHashSelector} from '../PurchaseOrderListPage/purchaseOrderListSelectors.js'
import {showPurchaseOrderNavSelector} from '../../data/pos.js'
import {
  showAnalyticsNavSelector,
  defaultAnalyticsHashSelector,
} from '../AnalyticsPage/analyticsSelectors.js'
import {defaultReturnOrderListHashSelector} from '../ReturnOrderListPage/returnOrderListSelectors.js'
import {canUseReturnOrdersSelector} from '../../redux/selectors/data/returnOrders.js'
import {showMONavSelector} from '../../data/mos.js'
import {defaultMOListHashSelector} from '../MOListPage/moListSelectors.js'
import {defaultOrderListHashSelector} from '../OrderListPage/orderListSelectors.js'
import {DASHBOARD_URI_COMPONENT} from '../DashboardPage/dashboardFunctions.js'
import {
  ORDER_PLURAL_URI_COMPONENT,
  ORDER_SINGLE_URI_COMPONENT,
} from '../../common/constants/Orders.js'
import {
  RETURN_ORDER_PLURAL_URI_COMPONENT,
  RETURN_ORDER_SINGLE_URI_COMPONENT,
} from '../../common/constants/ReturnOrders.js'
import {
  PRODUCT_PLURAL_URI_COMPONENT,
  PRODUCT_SINGLE_URI_COMPONENT,
} from '../../common/constants/Products.js'
import {
  PURCHASE_ORDER_PLURAL_URI_COMPONENT,
  PURCHASE_ORDER_SINGLE_URI_COMPONENT,
} from '../../common/constants/PurchaseOrders.js'
import {
  MO_PLURAL_URI_COMPONENT,
  MO_SINGLE_URI_COMPONENT,
} from '../../common/constants/MOs.js'
import {ANALYTICS_URI_COMPONENT} from '../../common/constants/Analytics.js'
import {BATCH_PLURAL_URI_COMPONENT} from '../../common/constants/Batches.js'
import {locationSelector} from '../../redux/selectors/ui/location.js'
import {userTabsSelector} from '../../data/me.js'
import {showWelcomeNavSelector} from '../WelcomePage/index.js'
import {WELCOME_URI_COMPONENT} from '../../common/constants/index.js'
import {STOCKTAKE_URI_COMPONENT} from '../../common/constants/Stocktakes.js'
import {DATA_IMPORT} from '../dataImport/DataImportLocationListener.js'
import {
  canUseReportsPageSelector,
  panelLinkSelector,
  REPORTS_PAGE_URI_COMPONENT,
  REPORTS_PANEL_ACTIVITY,
} from '../ReportsPage/reportsPageSelectors.js'
import {createSelector} from 'reselect'
import isEqual from 'lodash/isEqual.js'
import {buildPath} from '../../common/querystring.js'
import hashParse from '../../common/parseHash.js'
import {canUseDataImportSelector} from '../dataImport/dataImportFunctions.js'

export const HEADER_NAV_DROPDOWN = 'HEADER_NAV_DROPDOWN'
export const HEADER_SETTINGS_DROPDOWN = 'HEADER_SETTINGS_DROPDOWN'
export const HEADER_SUPPORT_DROPDOWN = 'HEADER_SUPPORT_DROPDOWN'

export const MAX_MAIN_TABS = 8

export const WELCOME_TAB = 'welcome'
const DASHBOARD_TAB = 'dashboard'
const ORDERS_TAB = 'orders'
const RETURNS_TAB = 'returns'
const PRODUCTS_TAB = 'products'
const POS_TAB = 'pos'
const MANUFACTURING_TAB = 'manufacturing'
const ANALYTICS_TAB = 'analytics'
const DATA_IMPORT_TAB = 'data_import'
const REPORTS_TAB = 'reports'
const DATA_EXPORT_TAB = 'data_export'

export const CAN_HIDE_TAB = [WELCOME_TAB]

const DEFAULT_TABS = [
  {
    type: WELCOME_TAB,
    display: 'Welcome',
    uris: [WELCOME_URI_COMPONENT, ''],
    pathComponents: [WELCOME_URI_COMPONENT],
    includeSelector: showWelcomeNavSelector,
  },
  {
    type: DASHBOARD_TAB,
    display: 'Dashboard',
    uris: [DASHBOARD_URI_COMPONENT, ''],
    pathComponents: [DASHBOARD_URI_COMPONENT],
  },
  {
    type: ORDERS_TAB,
    display: 'Orders',
    uris: [
      ORDER_PLURAL_URI_COMPONENT,
      ORDER_SINGLE_URI_COMPONENT,
      BATCH_PLURAL_URI_COMPONENT,
    ],
    defaultHashSelector: defaultOrderListHashSelector,
    countSelector: awaitingFulfillmentCountSelector,
    includeSelector: canUseOrdersSelector,
  },
  {
    type: RETURNS_TAB,
    display: 'Returns',
    uris: [
      RETURN_ORDER_PLURAL_URI_COMPONENT,
      RETURN_ORDER_SINGLE_URI_COMPONENT,
    ],
    defaultHashSelector: defaultReturnOrderListHashSelector,
    includeSelector: canUseReturnOrdersSelector,
  },
  {
    type: PRODUCTS_TAB,
    display: 'Products',
    uris: [
      PRODUCT_PLURAL_URI_COMPONENT,
      PRODUCT_SINGLE_URI_COMPONENT,
      STOCKTAKE_URI_COMPONENT,
    ],
    defaultHashSelector: defaultProductListHashSelector,
    includeSelector: canUseProductsSelector,
  },
  {
    type: POS_TAB,
    display: 'POs',
    uris: [
      PURCHASE_ORDER_PLURAL_URI_COMPONENT,
      PURCHASE_ORDER_SINGLE_URI_COMPONENT,
    ],
    defaultHashSelector: defaultPurchaseOrderListHashSelector,
    includeSelector: showPurchaseOrderNavSelector,
  },
  {
    type: MANUFACTURING_TAB,
    display: 'Manufacturing',
    uris: [MO_PLURAL_URI_COMPONENT, MO_SINGLE_URI_COMPONENT],
    defaultHashSelector: defaultMOListHashSelector,
    includeSelector: showMONavSelector,
  },
  {
    type: ANALYTICS_TAB,
    display: 'Analytics',
    uris: [ANALYTICS_URI_COMPONENT],
    defaultHashSelector: defaultAnalyticsHashSelector,
    includeSelector: showAnalyticsNavSelector,
  },
  {
    type: DATA_IMPORT_TAB,
    display: 'Data Import',
    uris: [DATA_IMPORT],
    pathComponents: [DATA_IMPORT],
    overflow: true,
    includeSelector: canUseDataImportSelector,
  },
  {
    type: REPORTS_TAB,
    display: 'Reports',
    uris: [REPORTS_PAGE_URI_COMPONENT],
    pathComponents: [REPORTS_PAGE_URI_COMPONENT],
    overflow: true,
    includeSelector: canUseReportsPageSelector,
  },
  {
    type: DATA_EXPORT_TAB,
    display: 'Data Export',
    uris: [REPORTS_PAGE_URI_COMPONENT],
    defaultHashSelector: (state) =>
      panelLinkSelector(state, {panel: REPORTS_PANEL_ACTIVITY}),
    overflow: true,
    includeSelector: canUseReportsPageSelector,
  },
]

function tabSelector(state, {tab}) {
  let url = tab.pathComponents
    ? '#' + buildPath(tab.pathComponents, tab.query)
    : tab.defaultHashSelector && tab.defaultHashSelector(state)

  const {pathComponents, query} = hashParse(url)

  const uris = tab.uris || [pathComponents[0]]

  return {
    type: tab.type,
    display: tab.display,
    url,
    pathComponents,
    query,
    attention: tab.countSelector ? tab.countSelector(state) : 0,
    uris,
    hide: tab.hide === true,
    overflow: !!tab.overflow,
  }
}

export function buildTabsSelector(state, {userTabs = []} = {}) {
  const location = locationSelector(state)
  const root = location.pathComponents[0] || ''

  // hide tabs that aren't included (like no permission)
  const defaultTabs = DEFAULT_TABS.filter(
    ({includeSelector}) => !includeSelector || includeSelector(state),
  )
  const defaultTabsByType = defaultTabs.reduce((prev, tab) => {
    prev[tab.type] = tab

    return prev
  }, {})

  // tab types that the user saved must be available
  userTabs = userTabs.filter(({type}) => defaultTabsByType[type])

  // figure out if saved user tabs follows the default order
  // so that we know if we can use the default order
  //
  // saved user tabs are always in the order the user expects them in
  // even if they are sparse because we only save sparse
  // if order is unchanged from default
  let indexOfUserTabs = 0
  for (const dTab of defaultTabs) {
    const uTab = userTabs[indexOfUserTabs]

    if (!uTab) {
      // got to the end of user tabs
      break
    }

    if (dTab.type === uTab.type) {
      // found it
      indexOfUserTabs += 1
    }
  }

  // if we looped through all default tabs in order
  // and we didn't increment through each saved user tab
  // then we didn't encounter the tabs in the same order
  let tabs = []
  if (userTabs.length === indexOfUserTabs) {
    // using default tabs as order

    let indexOfUserTabs = 0
    for (const dTab of defaultTabs) {
      const uTab = userTabs[indexOfUserTabs]

      if (dTab.type === uTab?.type) {
        // found it
        indexOfUserTabs += 1

        // include saved tab info
        tabs.push({...dTab, ...uTab})
      } else {
        tabs.push({...dTab})
      }
    }
  } else {
    // using saved user tabs as order

    // follow the userTab structure
    // because we saved the whole list out of order of default
    for (const uTab of userTabs) {
      const dTab = defaultTabsByType[uTab.type]

      tabs.push({...dTab, ...uTab})
    }

    // find and add missing default tabs to the end
    // these might be new tabs
    // or they might be tabs that the user now has permission to see
    defaultTabs
      .filter(({type}) => !userTabs.find((uTab) => uTab.type === type))
      .forEach((dTab) => tabs.push({...dTab}))
  }

  // get all the dynamic info
  tabs = tabs.map((tab) => tabSelector(state, {tab}))

  const hash = window.location.hash

  let selectedIndex = null

  // find the most selected tab
  for (const [index, tab] of tabs.entries()) {
    // if it's an exact match then god damn it it's selected
    if (tab.url === hash) {
      selectedIndex = index

      break
    }

    // otherwise check to see if the uris list matches current root
    if (tab.uris && tab.uris.includes(root)) {
      selectedIndex = index

      break
    }

    tab.selected = false
  }

  // apply selected value
  if (tabs[selectedIndex]) {
    tabs[selectedIndex].selected = true
  }

  return tabs
}

export function tabsSelector(state) {
  const cache = tabsSelector.cache

  const userTabs = userTabsSelector(state)

  const tabs = buildTabsSelector(state, {userTabs})

  if (isEqual(cache.results, tabs)) {
    return cache.results
  }

  cache.results = tabs

  return tabs
}
tabsSelector.cache = {}

export function getMainTabs(tabs) {
  tabs = tabs.filter(({overflow}) => !overflow)

  return tabs.slice(0, MAX_MAIN_TABS)
}

export const mainTabsSelector = createSelector(tabsSelector, getMainTabs)

export const overflowTabsSelector = createSelector(
  tabsSelector,
  mainTabsSelector,
  // assume that mainTabsSelector keeps the same object references as tabsSelector
  (tabs, mainTabs) => tabs.filter((tab) => !mainTabs.includes(tab)),
)

export function hasWelcomeTabSelector(state) {
  return !!tabsSelector(state).find(
    ({type, hide}) => !hide && type === WELCOME_TAB,
  )
}

function cleanForSaving(tabs) {
  return tabs.reduce((prev, tab) => {
    const t = {
      type: tab.type,
      display: tab.display,
      url: tab.url,
    }

    if (tab.overflow === true) {
      t.overflow = true
    }

    if (tab.hide === true) {
      t.hide = true
    }

    if (tab.pathComponents) {
      t.pathComponents = tab.pathComponents
    }

    if (tab.query) {
      t.query = tab.query
    }

    prev.push(tab)

    return prev
  }, [])
}

export function saveableTabStateSelector(state, {tabs}) {
  // clean the tabs of just the saveable properties
  tabs = cleanForSaving(tabs)
  // clean the baseline the same way
  const baseline = cleanForSaving(buildTabsSelector(state))

  // collect new tabs
  let newTabs = []

  // figure out if we need to save the whole list or just baseline adjustments
  // first if list length is different then we need complete list
  let needCompleteList = tabs.length !== baseline.length

  // trim each tab to include only the type and overrides from baseline
  for (const [index, tab] of tabs.entries()) {
    // get baseline tab
    const bTab = baseline.find(({type}) => type === tab.type)

    // type is constant and required
    const newTab = {type: tab.type}

    // loop through each other property
    for (const property of [
      'display',
      'url',
      'overflow',
      'hide',
      'pathComponents',
      'query',
    ]) {
      const value = tab[property]

      // and if the value is different than the baseline
      if (!isEqual(value, bTab[property])) {
        // keep it
        newTab[property] = value
      }
    }

    // keep all
    newTabs.push(newTab)

    // is the tab at this index different than the tab at the baseline index
    if (!needCompleteList) {
      needCompleteList = tab.type !== baseline[index].type
    }
  }

  if (!needCompleteList) {
    // remove any tab that is just 'type'
    newTabs = newTabs.reduce((prev, tab) => {
      // 'type' is required so if 1 key then it is just 'type'
      if (Object.keys(tab).length !== 1) {
        prev.push(tab)
      }

      return prev
    }, [])
  }

  return newTabs
}
